const initialState = {
  showMeleeTargets: false, // Отобразить смежные отряды противников для выбранного отряда для выбора приоритетной цели
};

const combatReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_MELEE_TARGETS_FOR_PRIORITY_SELECT': {
      return {
        ...state,
        showMeleeTargets: true,
      };
    }
    case 'COMPLETE_PHASE':
    case 'SET_WAR_PHASE_STAGE':
    case 'HIDE_MELEE_TARGETS_FOR_PRIORITY_SELECT': {
      return {
        ...state,
        showMeleeTargets: false,
      };
    }

    default:
      return state;
  }
};

export default combatReducer;
